import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as retrieveDocuments from "./retrieveDocuments";
import * as uploadDocument from "./uploadDocument";
import * as createFolder from "./createFolder";
import * as removeFolder from "./removeFolder";
import * as removeDocument from "./removeDocument";
import * as downloadDocumentContent from "./downloadDocumentContent";
import * as downloadFolderContent from "./downloadFolderContent";
import * as attachDocumentsToElement from "./attachDocumentsToElement";
import * as removeAttachedDocument from "./removeAttachedDocument";
import * as retrieveElementAttachments from "./retrieveElementAttachments";
import * as moveDocument from "./moveDocument";
import * as retrieveDocumentTemplates from "./retrieveDocumentTemplatesFolder";
import * as createDocument from "./createDocument";
import * as retrieveDocumentKey from "./retrieveDocumentKey";
import * as retrieveDocumentEditionToken from "./retrieveDocumentEditionToken";
import * as updateFolder from "./updateFolder";
import * as copyDocument from "./copyDocument";
import * as updateDocument from "./updateDocument";
import * as retrievePrivateDocuments from "./retrievePrivateDocuments";
import * as moveFolder from "./moveFolder";

const initialState: State = {
  retrieveDocuments: retrieveDocuments.initialState,
  uploadDocument: uploadDocument.initialState,
  createFolder: createFolder.initialState,
  removeFolder: removeFolder.initialState,
  removeDocument: removeDocument.initialState,
  downloadDocumentContent: downloadDocumentContent.initialState,
  downloadFolderContent: downloadFolderContent.initialState,
  attachDocumentsToElement: attachDocumentsToElement.initialState,
  removeAttachedDocument: removeAttachedDocument.initialState,
  retrieveElementAttachments: retrieveElementAttachments.initialState,
  moveDocument: moveDocument.initialState,
  retrieveDocumentTemplates: retrieveDocumentTemplates.initialState,
  createDocument: createDocument.initialState,
  retrieveDocumentKey: retrieveDocumentKey.initialState,
  retrieveDocumentEditionToken: retrieveDocumentEditionToken.initialState,
  updateFolder: updateFolder.initialState,
  copyDocument: copyDocument.initialState,
  updateDocument: updateDocument.initialState,
  retrievePrivateDocuments: retrievePrivateDocuments.initialState,
  moveFolder: moveFolder.initialState,
};

const reduceState = combineStateReducer(initialState, {
  retrieveDocuments: retrieveDocuments.reduceState,
  uploadDocument: uploadDocument.reduceState,
  createFolder: createFolder.reduceState,
  removeFolder: removeFolder.reduceState,
  removeDocument: removeDocument.reduceState,
  downloadDocumentContent: downloadDocumentContent.reduceState,
  downloadFolderContent: downloadFolderContent.reduceState,
  attachDocumentsToElement: attachDocumentsToElement.reduceState,
  removeAttachedDocument: removeAttachedDocument.reduceState,
  retrieveElementAttachments: retrieveElementAttachments.reduceState,
  moveDocument: moveDocument.reduceState,
  retrieveDocumentTemplates: retrieveDocumentTemplates.reduceState,
  createDocument: createDocument.reduceState,
  retrieveDocumentKey: retrieveDocumentKey.reduceState,
  retrieveDocumentEditionToken: retrieveDocumentEditionToken.reduceState,
  updateFolder: updateFolder.reduceState,
  copyDocument: copyDocument.reduceState,
  updateDocument: updateDocument.reduceState,
  retrievePrivateDocuments: retrievePrivateDocuments.reduceState,
  moveFolder: moveFolder.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...retrieveDocuments.createSelector(() => getState().retrieveDocuments),
    ...uploadDocument.createSelector(() => getState().uploadDocument),
    ...createFolder.createSelector(() => getState().createFolder),
    ...removeFolder.createSelector(() => getState().removeFolder),
    ...removeDocument.createSelector(() => getState().removeDocument),
    ...downloadDocumentContent.createSelector(
      () => getState().downloadDocumentContent,
    ),
    ...downloadFolderContent.createSelector(
      () => getState().downloadFolderContent,
    ),
    ...attachDocumentsToElement.createSelector(
      () => getState().attachDocumentsToElement,
    ),
    ...removeAttachedDocument.createSelector(
      () => getState().removeAttachedDocument,
    ),
    ...retrieveElementAttachments.createSelector(
      () => getState().retrieveElementAttachments,
    ),
    ...moveDocument.createSelector(() => getState().moveDocument),
    ...retrieveDocumentTemplates.createSelector(
      () => getState().retrieveDocumentTemplates,
    ),
    ...createDocument.createSelector(() => getState().createDocument),
    ...retrieveDocumentKey.createSelector(() => getState().retrieveDocumentKey),
    ...retrieveDocumentEditionToken.createSelector(
      () => getState().retrieveDocumentEditionToken,
    ),
    ...updateFolder.createSelector(() => getState().updateFolder),
    ...copyDocument.createSelector(() => getState().copyDocument),
    ...updateDocument.createSelector(() => getState().updateDocument),
    ...retrievePrivateDocuments.createSelector(
      () => getState().retrievePrivateDocuments,
    ),
    ...moveFolder.createSelector(() => getState().moveFolder),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
